(() => {
  const params = new URLSearchParams(location.search);
  const back = document.querySelector('[data-review-back]');
  if (back) {
    const url = new URL(back.href, location.href);
    for (const key of ['preview_theme_id', 'country', 'locale', 'variant']) {
      if (params.has(key)) url.searchParams.set(key, params.get(key));
    }
    back.href = url.href;
  }
  if (!params.has('hsg_write')) return;
  let finished = false;
  const observer = new MutationObserver(open);
  function open() {
    if (finished) return;
    const button = document.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link');
    if (!button || !button.getClientRects().length) return;
    finished = true;
    observer.disconnect();
    button.click();
  }
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  open();
  setTimeout(() => observer.disconnect(), 20000);
})();
